import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { ImagemLogo } from "../../components/imagensDinamicas"
import { setLocal } from "../../utils/localStorageOps"

function Redirecionamento() {
  const params = useParams()
  const navigate = useNavigate()
  useEffect(()=>{
    const buscaLinkId = async() => {
      const { redirecionamento_id } = params
      setLocal('link_parceiro',redirecionamento_id)
      navigate('/cadastro/passo0')
    }
    buscaLinkId()
  },[])

  return (
    <div>
      <ImagemLogo/>
      <h1>Redirecionando para o cadastro...</h1>
    </div>
  )
}

export default Redirecionamento